import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getEnquiryHotelVenueListUrl, getEnquiryHotelVenueDetailsUrl, insertUpdateEnquiryHotelVenueUrl, insertUpdateOtherHotelUrl, deleteEnquiryHotelVenueUrl, GET_ENQUIRY_HOTEL_VENUE_LIST, GET_ENQUIRY_HOTEL_VENUE_DETAILS, INSERT_UPDATE_ENQUIRY_HOTEL_VENUE, INSERT_UPDATE_OTHER_HOTEL, DELETE_ENQUIRY_HOTEL_VENUE } from "../../../../utils/constants";

export const getEnquiryHotelVenueList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID')
        }

        const res = await axiosGet(getEnquiryHotelVenueListUrl, params, headers)

        dispatch({
            type: GET_ENQUIRY_HOTEL_VENUE_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getEnquiryHotelVenueDetails_action = (EnquiryHotelVenueID, OtherHotelID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            EnquiryHotelVenueID: EnquiryHotelVenueID,
            OtherHotelID: OtherHotelID,
        }

        const res = await axiosGet(getEnquiryHotelVenueDetailsUrl, params, headers)

        dispatch({
            type: GET_ENQUIRY_HOTEL_VENUE_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateEnquiryHotelVenue_action = (EnquiryHotelVenueID, HotelName, HotelAddress, SingleOccupancyInINR, DoubleOccupancyInINR, SingleOccupancyInUSD, DoubleOccupancyInUSD, EnquiryHotelVenueList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            EnquiryHotelVenueID: EnquiryHotelVenueID,
            HotelName: HotelName,
            HotelAddress: HotelAddress,
            SingleOccupancyInINR: SingleOccupancyInINR,
            DoubleOccupancyInINR: DoubleOccupancyInINR,
            SingleOccupancyInUSD: SingleOccupancyInUSD,
            DoubleOccupancyInUSD: DoubleOccupancyInUSD,
            EnquiryHotelVenueList: EnquiryHotelVenueList,
        }

        const res = await axiosPost(insertUpdateEnquiryHotelVenueUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_ENQUIRY_HOTEL_VENUE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateOtherHotel_action = (OtherHotelID, HotelName, HotelAddress, PersonName, MobileNo, EmailId, Website) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            OtherHotelID: OtherHotelID,
            HotelName: HotelName,
            HotelAddress: HotelAddress,
            PersonName: PersonName,
            MobileNo: MobileNo,
            EmailId: EmailId,
            Website: Website,
        }

        const res = await axiosPost(insertUpdateOtherHotelUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_OTHER_HOTEL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteEnquiryHotelVenue_action = (EnquiryHotelVenueID, OtherHotelID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            EnquiryHotelVenueID: EnquiryHotelVenueID,
            OtherHotelID: OtherHotelID,
        }

        const res = await axiosGet(deleteEnquiryHotelVenueUrl, params, headers)

        dispatch({
            type: DELETE_ENQUIRY_HOTEL_VENUE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
